import React from 'react';
import { Id } from '../../types/Id';
import { StackedRibbonListProps } from '../../types/StackedRibbonListComponentTypes';
import { RibbonListHandles } from '../List/RibbonListHandles';
import {
  StackedRibbonListMinimalStatic,
  StackedRibbonListMinimalStaticProps,
} from '../Minimal/StackedRibbonListMinimalStatic';
import { ResultsHeaderWrapper } from '../ResultsHeader/ResultsHeaderWrapper';
import { useResultsHeaderWrapper } from '../ResultsHeader/useResultsHeaderWrapper';
import { useStackedRibbonList } from './useStackedRibbonList';

export interface StackedRibbonListStaticProps<TId extends Id, TItem>
  extends StackedRibbonListProps<TId, TItem>,
    StackedRibbonListMinimalStaticProps<TId, TItem> {}

/**
 * A StackedRibbonList with a header section whose contents are rendered statically in the DOM.
 */
export const StackedRibbonListStatic = React.memo(
  React.forwardRef(
    <TId extends Id, TItem>(
      props: StackedRibbonListStaticProps<TId, TItem>,
      ref: React.Ref<RibbonListHandles>,
    ) => {
      const headerWrapperProps = useResultsHeaderWrapper(props);
      const stackedRibbonListProps = useStackedRibbonList(props);

      const { height, maxHeight } = props;

      return (
        <ResultsHeaderWrapper {...headerWrapperProps}>
          <StackedRibbonListMinimalStatic
            {...stackedRibbonListProps}
            height={height}
            maxHeight={maxHeight}
            ref={ref}
          />
        </ResultsHeaderWrapper>
      );
    },
  ),
) as <TId extends Id, TItem>(
  props: StackedRibbonListStaticProps<TId, TItem> & { ref?: React.Ref<RibbonListHandles> },
) => JSX.Element;
